<template>
  <div class="flex flex-col gap-4 w-full">
    <AppDrawerFormFieldHeader
      :top-left="label"
      :bottom-left="description"
      :label-for="labelFor"
    />

    <div class="flex flex-col gap-4">
      <slot />
    </div>
  </div>
</template>

<script setup lang="ts">
defineProps({
  label: {
    type: String,
    required: true,
  },
  description: {
    type: String,
    required: false,
    default: '',
  },
  labelFor: {
    type: String,
    required: false,
    default: undefined,
  },
})
</script>
